module.exports = new __parcel__URL__("discord.5b244912.svg").toString();